import { Caption, H4 } from '@/components';
import CommonBlok from '@/components/common-blok';
import { LoadingImageUrl } from '@/constants';
import React from 'react';
import { IUsefulExample, UsefulExamplesList } from '../../constants';
import * as styles from './index.module.less';

const ExampleCard = (data: IUsefulExample) => {
  return (
    <div className={styles.example_card}>
      <div className={styles.example_card_pic}>
        <img className="lozad" src={LoadingImageUrl} data-src={data.withPic.src} alt={data.withPic.alt} />
      </div>
      <H4 className={styles.example_card_title}>{data.title}</H4>
      <Caption className={styles.example_card_caption}>{data.desc}</Caption>
    </div>
  );
};

const UsefulExample = () => {
  return (
    <CommonBlok title="ほかの便利な機能例" paddingBottom="0" isNewLayout className={styles.useful_example_container}>
      <div className={styles.blok_content}>
        {UsefulExamplesList.map((item, index) => {
          return <ExampleCard key={index} {...item} />;
        })}
      </div>
    </CommonBlok>
  );
};
export default UsefulExample;
